<template>
  <div class="h-topo-treebox">
    <div class="h-topo-tree">
      <ejs-treeview :fields='getDataSource' ref='alarmTree' :showCheckBox="true"></ejs-treeview>
    </div>
  </div>
</template>
<script>
export default {
  name: 'AlarmTopoTree',
  data() {
    return {
      dataSource: [],
      dataNe: [],
      dataEq: []
    };
  },
  computed: {
    getDataSource() {
      return {
        dataSource: this.dataSource,
        id: 'id',
        text: 'text',
        child: 'children',
        // iconCss: 'icon',
        tooltip: 'text',
      };
    }
  },
  props: {
    hasBorder: { type: Boolean, default: false },
  },
  watch: {
    dataNe() {
      const $this = this;
      const _dataSource = [];
      $this.dataEq.forEach((itemEq) => {
        const _childrenTemp = [];
        $this.dataNe.forEach((itemNe) => {
          if (itemEq.id === itemNe.equipmentId) {
            _childrenTemp.push(itemNe);
          }
        });
        itemEq.children = _childrenTemp;
        _dataSource.push(itemEq);
      });
      $this.dataSource = _dataSource;
    }
  },
  methods: {
    createEquipment() {
      const $this = this;
      this.$axios.post('/lte/ems/auth/findEquipmentListByAuth', []).then((response) => {
        $this.$axios.post('/lte/ems/auth/findElementListByAuth', []).then((responseNe) => {
          const _tempNe = [];
          const _nodeArrayNe = responseNe.data;
          _nodeArrayNe.forEach((_item) => {
            const { id, name, equipmentId } = _item;
            const _dataItemNe = {
              text: id+'_'+name,
              id: id,
              equipmentId: equipmentId,
            };
            _tempNe.push(_dataItemNe);
          });
          const _nodeArrayEq = response.data;
          const _tempEq = [];
          _nodeArrayEq.forEach((_item) => {
            const { id, name } = _item;
            const _dataItemEq = {
              text:id+'_'+ name,
              id: id,
              children: []
            };
            _tempEq.push(_dataItemEq);
          });
          $this.dataNe = _tempNe;
          $this.dataEq = _tempEq;
        });
      });
    },
    getCheckNode() {
      return this.$refs.alarmTree.getAllCheckedNodes();
    },
    createTree() {
      this.createEquipment();
    }
  },
};
</script>

<style scoped>

</style>
